import { render, staticRenderFns } from "./SelectedCourseBoxSimulate.vue?vue&type=template&id=38666979"
import script from "./SelectedCourseBoxSimulate.vue?vue&type=script&lang=js"
export * from "./SelectedCourseBoxSimulate.vue?vue&type=script&lang=js"
import style0 from "./SelectedCourseBoxSimulate.vue?vue&type=style&index=0&id=38666979&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports